<div id="view-branch-advisors-dialog">
    <div id="dialog-title" mat-dialog-title>
        <span id="dialog-header">Incepted APE - By Advisors [{{this.branchName}}]</span>
        <button mat-icon-button mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content>
        <div class="position-relative" style="max-width: 500px">
            <input type="text" class="form-control border-0 shadow-sm ps-5 pe-5"
                style="background: #f0f0f0; color: #1c3a7a" [formControl]="inceptedApeBranchAdvisorTableFilterFc"
                (keyup)="__applyInceptedApeBranchAdvisorsDataFilter()" placeholder="Search advisors..." #input />

            <i class="fas fa-search position-absolute top-50 ms-2 translate-middle-y" style="color: #888888"></i>

            <button *ngIf="inceptedApeBranchAdvisorTableFilterFc.value"
                class="btn position-absolute top-50 end-0 translate-middle-y me-5 p-0 border-0 bg-transparent"
                (click)="clearSearchField()">
                <i class="fas fa-times" style="color: #888888"></i>
            </button>
        </div>
        <mat-divider class="pias-divider"></mat-divider>
        <div id="view-branch-advisors-table">
            <table mat-table [dataSource]="this.inceptedApeByAdvisorTableDataSource" matSort matSortDisableClear
                matSortActive="yearTotal" matSortDirection="desc" #inceptedApeByAdvisorTableSort="matSort"
                class="pias-table table table-hover table-bordered bg-light border border-2">

                <!-- Rep Code Column (rowspan=2) -->
                <ng-container matColumnDef="repCode">
                    <th mat-header-cell *matHeaderCellDef rowspan="2" mat-sort-header
                        class="text-center align-middle fw-bold"> Rep. Code </th>
                    <td mat-cell *matCellDef="let apeData" class="text-start" style="max-width: 100px;"> {{apeData.repCode}} </td>
                </ng-container>

                <!-- Person Name Column (rowspan=2) -->
                <ng-container matColumnDef="personName">
                    <th mat-header-cell *matHeaderCellDef rowspan="2" mat-sort-header
                        class="text-center align-middle fw-bold"> Name </th>
                    <td mat-cell *matCellDef="let apeData" class="text-start" style="max-width: 150px;"> {{apeData.personName}} </td>
                </ng-container>

                <!-- Header Row2 month singlife group -->
                <ng-container matColumnDef="header-row2-month-singlife-group">
                    <th mat-header-cell *matHeaderCellDef colspan="2" class="text-center align-middle fw-bold">
                        Singlife (MTD)
                    </th>
                </ng-container>

                <!-- Header Row2 month nonsinglife group -->
                <ng-container matColumnDef="header-row2-month-nonsinglife-group">
                    <th mat-header-cell *matHeaderCellDef colspan="2" class="text-center align-middle fw-bold">
                        Non-Singlife (MTD)
                    </th>
                </ng-container>

                <!-- Header Row2 Year singlife group -->
                <ng-container matColumnDef="header-row2-year-singlife-group">
                    <th mat-header-cell *matHeaderCellDef colspan="2" class="text-center align-middle fw-bold">
                        Singlife (YTD)
                    </th>
                </ng-container>

                <!-- Header Row2 Year nonsinglife group -->
                <ng-container matColumnDef="header-row2-year-nonsinglife-group">
                    <th mat-header-cell *matHeaderCellDef colspan="2" class="text-center align-middle fw-bold">
                        Non-Singlife (YTD)
                    </th>
                </ng-container>

                <!-- Year Total Column (rowspan=2) -->
                <ng-container matColumnDef="yearTotal">
                    <th mat-header-cell *matHeaderCellDef rowspan="2" mat-sort-header
                        class="text-center align-middle fw-bold"> Year Total </th>
                    <td mat-cell *matCellDef="let apeData" class="text-end"> {{ apeData.yearTotal |
                        currency: 'SGD' :
                        'symbol-narrow' : '1.0-0'}} </td>
                </ng-container>

                <!-- Month Singlife APE Column -->
                <ng-container matColumnDef="monthSinglife">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold"> APE
                    </th>
                    <td mat-cell *matCellDef="let apeData" class="text-end"> {{apeData.monthSinglife | currency:
                        'SGD' :
                        'symbol-narrow' : '1.0-0'}} </td>
                </ng-container>

                <!-- Month Singlife Case Column -->
                <ng-container matColumnDef="monthSinglifeCase">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold"> Case
                    </th>
                    <td mat-cell *matCellDef="let apeData" class="text-center"> {{apeData.monthSinglifeCase}}
                    </td>
                </ng-container>

                <!-- Month Non-Singlife APE Column -->
                <ng-container matColumnDef="monthNonsinglife">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold"> APE
                    </th>
                    <td mat-cell *matCellDef="let apeData" class="text-end"> {{apeData.monthNonsinglife |
                        currency: 'SGD'
                        : 'symbol-narrow' : '1.0-0'}} </td>
                </ng-container>

                <!-- Month Non-Singlife Case Column -->
                <ng-container matColumnDef="monthNonsinglifeCase">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold"> Case
                    </th>
                    <td mat-cell *matCellDef="let apeData" class="text-center"> {{apeData.monthNonsinglifeCase}}
                    </td>
                </ng-container>

                <!-- Year Singlife APE Column -->
                <ng-container matColumnDef="yearSinglife">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold"> APE
                    </th>
                    <td mat-cell *matCellDef="let apeData" class="text-end"> {{apeData.yearSinglife | currency:
                        'SGD' :
                        'symbol-narrow' : '1.0-0'}} </td>
                </ng-container>

                <!-- Year Singlife Case Column -->
                <ng-container matColumnDef="yearSinglifeCase">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold"> Case
                    </th>
                    <td mat-cell *matCellDef="let apeData" class="text-center"> {{apeData.yearSinglifeCase}}
                    </td>
                </ng-container>

                <!-- Year Non-Singlife APE Column -->
                <ng-container matColumnDef="yearNonsinglife">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold"> APE
                    </th>
                    <td mat-cell *matCellDef="let apeData" class="text-end"> {{apeData.yearNonsinglife |
                        currency: 'SGD' :
                        'symbol-narrow' : '1.0-0'}} </td>
                </ng-container>

                <!-- Year Non-Singlife Case Column -->
                <ng-container matColumnDef="yearNonsinglifeCase">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center align-middle fw-bold"> Case
                    </th>
                    <td mat-cell *matCellDef="let apeData" class="text-center"> {{apeData.yearNonsinglifeCase}}
                    </td>
                </ng-container>

                <!-- First Header Row (with Rep Code, Name, Group Headers, and Year Total) -->
                <tr mat-header-row *matHeaderRowDef="inceptedApeByAdvisorTableDisplayFirstColumn; sticky: true">
                </tr>

                <!-- Second Header Row (with only APE and Case subheaders) -->
                <tr mat-header-row *matHeaderRowDef="inceptedApeByAdvisorTableDisplaySecondColumn; sticky: true">
                </tr>

                <!-- Data Row -->
                <tr mat-row *matRowDef="let row; columns: inceptedApeByAdvisorTableDisplayDataRow;"></tr>
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="11">No data found.</td>
                </tr>
            </table>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="center">
        <!-- Incepted APE Data Table Paginator -->
        <mat-paginator #inceptedApeByAdvisorTablePaginator [pageSizeOptions]="[10,20,50]" showFirstLastButtons
            aria-label="Select page of incepted APE data"></mat-paginator>
    </mat-dialog-actions>
</div>